// Geedel — Product page white background fix
(function(){
  if(window.location.pathname.includes('/products/')){
    var fixCss=document.createElement('style');
    fixCss.id='geedel-product-bg-fix';
    fixCss.textContent='body{background-color:#ffffff!important}#MainContent{background-color:#ffffff!important}';
    document.head.appendChild(fixCss);
  }
})();

// Geedel — Apple-Inspired Hover Enhancement
(function() {
  'use strict';
  function applyHoverEffects() {
    document.querySelectorAll('.product-card__image__container').forEach(function(el) {
      el.style.setProperty('transition', 'transform 0.45s cubic-bezier(0.25, 0.1, 0.25, 1)', 'important');
      el.style.setProperty('will-change', 'transform', 'important');
    });
    document.querySelectorAll('.product-card img').forEach(function(img) {
      img.style.setProperty('transition', 'transform 0.45s cubic-bezier(0.25, 0.1, 0.25, 1), filter 0.45s ease', 'important');
    });
    document.querySelectorAll('.product-card').forEach(function(card) {
      card.style.setProperty('transition', 'transform 0.4s cubic-bezier(0.25, 0.1, 0.25, 1)', 'important');
      card.addEventListener('mouseenter', function() { this.style.transform = 'translateY(-4px)'; });
      card.addEventListener('mouseleave', function() { this.style.transform = ''; });
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', applyHoverEffects); }
  else { applyHoverEffects(); }
  document.addEventListener('shopify:section:load', applyHoverEffects);
  document.addEventListener('shopify:block:select', applyHoverEffects);
})();
